import { TextBox } from '@homex/se-react-components';
import { CarouselItemId } from '@homex/se-widget-flow-types';
import React from 'react';
import { useSelector } from 'react-redux';

import { setSystemComments } from 'actions';
import { CarouselContinueButton } from 'components/CarouselContinueButton';
import { Phrase } from 'components/Phrase';
import { useThunkDispatch } from 'hooks/useThunkDispatch';
import { IState } from 'typings';

import { Buttons, Container, FormGroup, Subhead } from './styles';

export const CarouselItemSystemCommentsBottom = () => {
  const dispatch = useThunkDispatch();
  const { systemComments } = useSelector((state: IState) => ({
    systemComments: state.userInput.systemComments,
  }));

  const handleChange = (event: React.FormEvent<HTMLInputElement>) => {
    dispatch(setSystemComments(event.currentTarget.value));
  };

  return (
    <FormGroup>
      <Container>
        <Subhead>
          <Phrase id="SYSTEM_COMMENTS.SUBHEAD" />
        </Subhead>
        <TextBox
          isMultiline={true}
          label={Phrase({ id: 'SYSTEM_COMMENTS.LABEL' })}
          maxLength={300}
          onChange={handleChange}
          value={systemComments || ''}
        />
      </Container>
      <Buttons>
        <CarouselContinueButton
          destinationItemId={CarouselItemId.SalesSummary}
        />
      </Buttons>
    </FormGroup>
  );
};
